import client from './client';

export interface Anbiyam {
  anbiyamId:          number;
  anbiyamName:        string;
  anbiyamCode:        string;
  zone:               number;
  coordinatorName:    string;
  coordinatorPhone:   string;
  assCoordinatorName?: string;
  coordinatorEmail?:   string;
  familyCount?:        number;
}

export interface AnbiyamPayload {
  anbiyamName:        string;
  anbiyamCode?:       string;
  zone:               number;
  coordinatorName:    string;
  coordinatorPhone:   string;
  assCoordinatorName?: string;
  coordinatorEmail?:   string;
}

export interface PagedResult<T> {
  items:      T[];
  total:      number;
  page:       number;
  pageSize:   number;
  totalPages: number;
}

export const listAnbiyam = async (params: {
  page?: number; pageSize?: number; search?: string; zone?: number | null;
}): Promise<PagedResult<Anbiyam>> => {
  const { data } = await client.get<{ data: PagedResult<Anbiyam> }>('/anbiyam', { params });
  return data.data;
};

export const createAnbiyam = async (payload: AnbiyamPayload): Promise<Anbiyam> => {
  const { data } = await client.post<{ data: Anbiyam }>('/anbiyam', payload);
  return data.data;
};

export const updateAnbiyam = async (id: number, payload: Partial<AnbiyamPayload>): Promise<Anbiyam> => {
  const { data } = await client.put<{ data: Anbiyam }>(`/anbiyam/${id}`, payload);
  return data.data;
};

export const deleteAnbiyam = async (id: number): Promise<void> => {
  await client.delete(`/anbiyam/${id}`);
};

// Subscription progress per Anbiyam — its own endpoint, fetched
// independently of listAnbiyam, so the grid renders immediately and this
// column fills in once its own (heavier, multi-year) aggregation finishes.
// Money-based (₹ collected vs ₹ expected), not month-counting, since church
// subscriptions are often paid in irregular lump sums rather than monthly.
export interface AnbiyamSubscriptionProgress {
  anbiyamId:       number;
  expectedAmount:  number;
  collectedAmount: number;
  /** Distinct graves of families in this Anbiyam. */
  graveCount?:     number;
  /** Burial records (several can share one grave). */
  burialCount?:    number;
}

export const getAnbiyamSubscriptionProgress = async (): Promise<AnbiyamSubscriptionProgress[]> => {
  const { data } = await client.get<{ data: AnbiyamSubscriptionProgress[] }>('/anbiyam/subscription-progress');
  return data.data;
};
